<template>
  <div>
    <h2>{{ $t('filter.title') }}</h2>

    <b-form @submit.prevent="sendFilteredQuery">

      <div class="d-flex">
        <!--PRODUCT TYPE-->
        <b-form-group
          class="mr-4 w-100 mh-100"
          id="product-type-group"
          :label="$t('filter.by.products.product_type')"
          label-for="product-type"
        >
          <multiselect
            id="product-type"
            v-model="filterModels.productType"
            :select-label="$t('multiselect.select_label')"
            :selected-label="$t('multiselect.selected_label')"
            :placeholder="$t('multiselect.placeholder', { field: $t('form.products.product_type').toLowerCase() })"
            :options="productTypes"
            track-by="type"
            label="name">
          </multiselect>
        </b-form-group>

        <!--PRODUCT STATUS-->
        <b-form-group
          class="w-100 mh-100"
          id="status-group"
          :label="$t('filter.by.products.status')"
          label-for="status"
        >
          <multiselect
            id="active"
            :select-label="$t('multiselect.select_label')"
            :selected-label="$t('multiselect.selected_label')"
            :multiple="true"
            v-model="filterModels.status"
            :placeholder="$t('multiselect.placeholder', { field: $t('form.products.status').toLowerCase() })"
            :searchable="false"
            track-by="code"
            label="name"
            :options="productStatuses">
          </multiselect>
        </b-form-group>
      </div>

      <div class="d-flex justify-content-end">
        <b-button
          class="mb-2"
          @click="clearAllFilters"
          variant="primary">
          <b-icon icon="arrow-repeat"></b-icon>
          {{ $t('filter.reset_button') }}
        </b-button>
        <b-button
          class="mb-2 ml-3"
          type="submit"
          variant="success">
          <b-icon icon="check"></b-icon>
          {{ $t('filter.apply_button') }}
        </b-button>
      </div>

    </b-form>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import { PRODUCT_STATUSES } from '@user/configs'
  import { VAT_RATE_TYPES } from '@base/configs'

  const defaultFilterModels = {
    productType: null,
    status: null,
  }

  export default {
    name: 'ProductsFilter',

    components: {
      Multiselect
    },

    data () {
      return {
        productStatuses: PRODUCT_STATUSES,
        productTypes: VAT_RATE_TYPES,
        filterModels: {
          ...defaultFilterModels
        }
      }
    },

    computed: {
      productTypeArg () {
        return this.filterModels.productType ? this.filterModels.productType.prefix : null
      },

      statusArg () {
        return this.filterModels.status ? this.filterModels.status.map((statusObj) => statusObj.code) : null
      },

      filterArgs () {
        return {
          productType: this.productTypeArg,
          status: this.statusArg
        }
      }
    },

    methods: {
      clearAllFilters () {
        this.filterModels = { ...defaultFilterModels }
        this.$emit('filter-applied', this.filterArgs)
      },
      sendFilteredQuery () {
        this.$emit('filter-applied', this.filterArgs)
      }
    }
  }
</script>

<style scoped>

</style>
